import type { Tokens } from '@dhl-ui/theme'
import { spacing } from '../spacing'
import { type ComponentCreation } from './types'

export const createMuiTooltip = ({ palette }: Pick<Tokens, 'palette'>): ComponentCreation => ({
  MuiTooltip: {
    styleOverrides: {
      tooltip: {
        maxWidth: spacing(30),
        backgroundColor: palette.dark.main,
        color: palette.dark.contrastText,
        padding: spacing(0.5, 1),
      },
      arrow: {
        color: palette.dark.main,
      },
    },
  },
})
